<template>
  <Modal
    :modal-types="[upgradeType]"
    :should-add-content-padding="false"
    :is-wide-modal="true"
  >
    <div class="upgrade-account-modal-container">
      <div class="upgrade-account-modal-header-image">
        <img
          src="//d.stockcharts.com/img/chartwatchers/stockcharts-signup.jpg"
          alt="StockCharts Features"
        />
      </div>
      <h4 class="upgrade-account-restriction-heading">
        <slot name="reason-heading"></slot>
      </h4>
      <h2 class="upgrade-account-heading">
        <slot name="main-message"></slot>
      </h2>

      <slot name="sub-message"></slot>
      <slot name="button-group"></slot>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';
  import { useModals } from '@/composables/useModals';
  import Modal from '@/components/modals/Modal.vue';

  const { CREATE_ACCOUNT_MODAL, UPGRADE_TO_EXTRA_MODAL, UPGRADE_TO_PRO_MODAL } = useModals();
  const props = defineProps<{
    upgradeType: typeof CREATE_ACCOUNT_MODAL | typeof UPGRADE_TO_EXTRA_MODAL | typeof UPGRADE_TO_PRO_MODAL;
  }>();

  const { upgradeType } = toRefs(props);
</script>

<style>
  .upgrade-account-modal-container {
    text-align: center;
  }

  .upgrade-account-modal-container .upgrade-account-modal-header-image {
    border-radius: 6px 6px 0px 0px;
  }

  .upgrade-account-modal-container .upgrade-account-modal-header-image img {
    max-width: 100%;
  }

  .upgrade-account-modal-container .upgrade-account-restriction-heading {
    color: #ff1a29;
    margin: 0px 0px 6px 0px;
    line-height: 1.20;
    font-size: 20px;
    font-weight: 700;
  }

  .upgrade-account-modal-container .upgrade-account-heading {
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 40px;
    font-weight: 700;
    padding: 10px 24px;
    line-height: 1.2;
    margin: 0px;
    color: #383f47;
  }

  .upgrade-account-modal-container .upgrade-account-message,
  .upgrade-account-modal-container .upgrade-account-message-bold {
    padding: 10px 15px;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.45;
    color: #4f5964;
    margin: 0px;
  }

  .upgrade-account-modal-container .upgrade-account-message-bold {
    font-weight: 700;
  }

  .upgrade-account-modal-container .close-button {
    text-decoration: underline;
    color: #8d99a5;
    margin-bottom: 20px;
  }

  .upgrade-account-modal-container .close-button:hover,
  .upgrade-account-modal-container .close-button:active,
  .upgrade-account-modal-container .close-button:focus {
    color: #707f8f;
  }
</style>
